<template>
  <TravelersFilterPopup
    :title="title"
    :static-title="headerTitle"
    :is-modal-only="isTabletValue"
    :is-active="isActiveValue"
    class="filter-duration"
    filter-key="duration"
    :is-disabled-reset-button="isDisabledResetButton"
    :is-scroll="props.isScroll"
    :total-count="categoryStore.experiencesTmpCount"
    :is-loading="categoryStore.isExperiencesCountLoading"
    @open="applyModalStyles"
    @close="onClosePopup"
    @apply="categoryStore.onApplyFilter(EExperienceFilterType.DURATION)"
    @reset="categoryStore.onResetFilter(EExperienceFilterType.DURATION)"
  >
    <FilterDurationContent />
  </TravelersFilterPopup>
</template>

<script setup lang="ts">
  import { TravelersFilterPopup } from '@experience/travelers-filter-popup-package';
  import FilterDurationContent from './FilterDurationContent.vue';
  import { useFilterDurationTitle } from '@/features/filter/duration';
  import { useCategoryStore } from '@/shared/store';
  import { EExperienceFilterType } from '@/widgets/filtersBlock';
  import { useScreenSize } from '@experience/shared';
  import { applyModalStyles, resetModalStyles } from '@/shared/lib';
  import { computed } from 'vue';

  const { isTablet } = useScreenSize();

  interface Props {
    isScroll?: boolean;
  }

  const props = defineProps<Props>();

  const categoryStore = useCategoryStore();

  const { title, headerTitle, isActive } = useFilterDurationTitle();

  const isTabletValue = computed<boolean>(() => isTablet.value);
  const isActiveValue = computed<boolean>(() => isActive.value);

  const isDisabledResetButton = computed(() => {
    return (
      !categoryStore.tmpFilters[EExperienceFilterType.DURATION].duration[0] &&
      !categoryStore.tmpFilters[EExperienceFilterType.DURATION].duration[1]
    );
  });

  const onClosePopup = () => {
    resetModalStyles();
    categoryStore.onResetTmpFilter(EExperienceFilterType.DURATION);
  };
</script>

<style lang="scss" scoped>
  :deep(.filter-popup) {
    width: 368px;
    max-width: 100vw;

    .popup__header {
      padding-bottom: 11px;
    }

    .popup__content {
      padding-top: 5px;
    }
  }
</style>
